import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ActiviteitPage} from '../activiteit-page';
import {Zone} from '../../zone/zone';
import {Activiteit} from '../activiteit';
import {ActiviteitPageRequest} from '../activiteit-page-request';
import {Dienst} from '../../dienst/dienst';

@Component({
    selector: 'zah-activiteiten',
    templateUrl: './activiteiten.component.html',
    styleUrls: ['./activiteiten.component.scss'],
    standalone: false
})
export class ActiviteitenComponent {

  @Input()
  initialPageRequest: ActiviteitPageRequest;
  @Input()
  activiteitenPage: ActiviteitPage;
  @Input()
  zones: Array<Zone>;
  @Input()
  diensten: Array<Dienst>;
  @Output()
  verwerkClicked: EventEmitter<Activiteit> = new EventEmitter<Activiteit>();
  @Output()
  activiteitClicked: EventEmitter<Activiteit> = new EventEmitter<Activiteit>();
  @Output()
  pageChange: EventEmitter<ActiviteitPageRequest> = new EventEmitter<ActiviteitPageRequest>();

  selectedActiviteit: Activiteit;

  openActiviteit(activiteit: Activiteit): void {
    this.selectedActiviteit = activiteit;
  }

  onVerwerkClicked(activiteit: Activiteit): void {
    this.selectedActiviteit = undefined;
    this.verwerkClicked.emit(activiteit);
  }

  onActiviteitCardClicked(activiteit: Activiteit): void {
    this.activiteitClicked.emit(activiteit);
  }

  onPageChange(pageRequest: ActiviteitPageRequest): void {
    this.selectedActiviteit = undefined;
    this.pageChange.emit(pageRequest);
  }
}
